var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ModelManager, getSafeStorage, getStatsigClient, getCartItemsIdsString, getOrCreateStatsigManager, buildModelRequestPayload, shouldSendPayload, } from './statsig-manager.js';
const MODEL_KEY = "statsig:dyo:promos4u_3";
const PROMOTION_COUPON_STORAGE_KEY = "insider:cart:promotionCoupon";
const EXPERIMENT = {
    title: "Promos4U",
    name: "dyo-promos4u",
    gate: "dyo-promos4u",
    layer: "dyo-promos4u",
    allocated_experiment: "",
};
if (!customElements.get("promos-4u"))
    customElements.define("promos-4u", class Promos4U extends HTMLElement {
        constructor() {
            super();
            this.statsigStableId = null;
            this.allocatedExperiment = null;
            this.listCoupon = null;
            this.coupon = null;
            this.fallbackElement = null;
            this.modelUrl = null;
            this.REQUEST_TIMEOUT_MS = 10000;
            this.PROMOTION_WAIT_TIMEOUT_MS = 5000;
            this.PROMOTION_POLL_INTERVAL_MS = 100;
            this.PROMOTION_RETRY_WINDOW_MS = 15000;
            this.PROMOTION_RETRY_INTERVAL_MS = 250;
            this.hasStartedStatsig = false;
            this.modelManager = new ModelManager();
            this.customerId = this.getAttribute("data-customer-id") || null;
            this.statsigGate = this.getAttribute("data-statsig-gate") || EXPERIMENT.gate;
            this.statsigLayer = this.getAttribute("data-statsig-layer") || EXPERIMENT.layer;
            this.listCoupon = this.querySelector("#list").textContent || null;
            this.coupon = null;
            this.fallbackElement = null;
            this.obgExperimentInfos = {
                stable_id: this.statsigStableId,
                gate: this.statsigGate,
                layer: this.statsigLayer,
                cart: getCartItemsIdsString(),
                customer_id: this.customerId,
                allocated_experiment: EXPERIMENT.allocated_experiment,
                category: "Statsig",
                component: EXPERIMENT.name,
            };
            this.debugLog("constructor", {
                customerId: this.customerId,
                statsigGate: this.statsigGate,
                statsigLayer: this.statsigLayer,
            });
        }
        debugLog(_message, _payload) { }
        debugPromotionStatus(_status, _reason, _payload) { }
        connectedCallback() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    this.debugLog("connectedCallback:start");
                    const promotionStatus = yield this.waitForPromotionStatus();
                    this.debugLog("connectedCallback:resolved promotion status", { promotionStatus });
                    if (promotionStatus === "blocked")
                        return;
                    if (promotionStatus === "pending") {
                        this.retryStartWhenPromotionReady();
                        return;
                    }
                    yield this.startStatsig();
                }
                catch (error) {
                    console.log("Error initializing Statsig manager:", error);
                }
            });
        }
        retryStartWhenPromotionReady() {
            const startAt = Date.now();
            this.debugLog("retryStartWhenPromotionReady:start", {
                retryWindowMs: this.PROMOTION_RETRY_WINDOW_MS,
                retryIntervalMs: this.PROMOTION_RETRY_INTERVAL_MS,
            });
            const attemptStart = () => __awaiter(this, void 0, void 0, function* () {
                const status = this.verifyPromotion();
                if (status === "blocked")
                    return;
                if (status === "allowed") {
                    this.debugLog("retryStartWhenPromotionReady:status allowed, trying startStatsig");
                    try {
                        yield this.startStatsig();
                    }
                    catch (error) {
                        console.log("Error in retryStartWhenPromotionReady:", error);
                    }
                    return;
                }
                if (Date.now() - startAt >= this.PROMOTION_RETRY_WINDOW_MS) {
                    this.debugLog("retryStartWhenPromotionReady:timeout window reached");
                    return;
                }
                window.setTimeout(() => {
                    void attemptStart();
                }, this.PROMOTION_RETRY_INTERVAL_MS);
            });
            void attemptStart();
        }
        waitForPromotionStatus() {
            return __awaiter(this, void 0, void 0, function* () {
                const immediateStatus = this.verifyPromotion();
                this.debugLog("waitForPromotionStatus:immediate", { immediateStatus });
                if (immediateStatus !== "pending") {
                    return immediateStatus;
                }
                return new Promise((resolve) => {
                    let settled = false;
                    const settle = (status) => {
                        if (settled)
                            return;
                        settled = true;
                        window.removeEventListener("PromotionCouponReady", onPromotionReady);
                        clearInterval(pollInterval);
                        clearTimeout(timeoutHandle);
                        this.debugLog("waitForPromotionStatus:settle", { status });
                        resolve(status);
                    };
                    const checkStatus = () => {
                        const status = this.verifyPromotion();
                        if (status !== "pending") {
                            settle(status);
                        }
                    };
                    const onPromotionReady = () => {
                        this.debugLog("waitForPromotionStatus:event PromotionCouponReady");
                        checkStatus();
                    };
                    const pollInterval = window.setInterval(checkStatus, this.PROMOTION_POLL_INTERVAL_MS);
                    const timeoutHandle = window.setTimeout(() => {
                        this.debugLog("waitForPromotionStatus:timeout reached");
                        settle(this.verifyPromotion());
                    }, this.PROMOTION_WAIT_TIMEOUT_MS);
                    window.addEventListener("PromotionCouponReady", onPromotionReady, { once: true });
                });
            });
        }
        startStatsig() {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.hasStartedStatsig) {
                    this.debugLog("startStatsig:already started");
                    return;
                }
                const promotionStatus = this.verifyPromotion();
                if (promotionStatus !== "allowed") {
                    this.debugLog("startStatsig:blocked by promotion status", { promotionStatus });
                    return;
                }
                this.hasStartedStatsig = true;
                this.debugLog("startStatsig:initializing manager");
                yield getOrCreateStatsigManager();
                this.debugLog("startStatsig:running test");
                yield this.runTest();
            });
        }
        persistForcedPromos4UCoupon(discountValue) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                const couponCode = (this.coupon || "").trim().toUpperCase();
                if (!couponCode)
                    return;
                const currentStorage = this.getPromotionCouponFromStorage() || {};
                const currentStorageCode = this.getEffectivePromotionCouponCode(currentStorage);
                const hasSameForcedCoupon = currentStorageCode === couponCode && currentStorage.force === true;
                if (hasSameForcedCoupon) {
                    this.debugLog("persistForcedPromos4UCoupon:already persisted", {
                        couponCode,
                    });
                    return;
                }
                let validatedCouponData = null;
                if (typeof validateDiscountCode === "function") {
                    try {
                        validatedCouponData = yield validateDiscountCode(couponCode);
                    }
                    catch (error) {
                        this.debugLog("persistForcedPromos4UCoupon:validate failed", {
                            couponCode,
                            error,
                        });
                    }
                }
                const fallbackDiscountData = {
                    discount: {
                        allocation_method: "across",
                        target_selection: "all",
                        target_type: "line_item",
                        value: String(Math.round(discountValue * 100)),
                        value_type: "percentage",
                        allocation_limit: null,
                        entitled_product_ids: [],
                        entitled_variant_ids: [],
                        entitled_collection_ids: [],
                        usage_count: 0,
                        usage_limit: null,
                        changed_value: false,
                        code: couponCode,
                    },
                };
                const resolvedDiscountPayload = (validatedCouponData === null || validatedCouponData === void 0 ? void 0 : validatedCouponData.discount) || ((_a = validatedCouponData === null || validatedCouponData === void 0 ? void 0 : validatedCouponData.data) === null || _a === void 0 ? void 0 : _a.discount)
                    ? {
                        discount: (validatedCouponData === null || validatedCouponData === void 0 ? void 0 : validatedCouponData.discount) || ((_b = validatedCouponData === null || validatedCouponData === void 0 ? void 0 : validatedCouponData.data) === null || _b === void 0 ? void 0 : _b.discount),
                    }
                    : fallbackDiscountData;
                const payload = Object.assign(Object.assign({}, currentStorage), { code: couponCode, force: true, promos4u_preview: true, data: resolvedDiscountPayload });
                if (validatedCouponData === null || validatedCouponData === void 0 ? void 0 : validatedCouponData.discount_default) {
                    payload.discount_default = validatedCouponData.discount_default;
                }
                if (typeof (validatedCouponData === null || validatedCouponData === void 0 ? void 0 : validatedCouponData.disable_default_message) !== "undefined") {
                    payload.disable_default_message = validatedCouponData.disable_default_message;
                }
                if (validatedCouponData === null || validatedCouponData === void 0 ? void 0 : validatedCouponData.discount_config) {
                    payload.discount_config = validatedCouponData.discount_config;
                }
                sessionStorage.setItem(PROMOTION_COUPON_STORAGE_KEY, JSON.stringify(payload));
                window.dispatchEvent(new CustomEvent("PromotionCouponReady"));
                this.debugLog("persistForcedPromos4UCoupon:stored", {
                    couponCode,
                    usedValidatedPayload: !!validatedCouponData,
                });
            });
        }
        getEffectivePromotionCouponCode(promotionCoupon) {
            var _a, _b;
            const normalizedCode = (promotionCoupon === null || promotionCoupon === void 0 ? void 0 : promotionCoupon.code) ||
                (typeof (promotionCoupon === null || promotionCoupon === void 0 ? void 0 : promotionCoupon.discount) === "string" ? promotionCoupon.discount : null) ||
                (typeof ((_a = promotionCoupon === null || promotionCoupon === void 0 ? void 0 : promotionCoupon.data) === null || _a === void 0 ? void 0 : _a.discount) === "string"
                    ? promotionCoupon.data.discount
                    : typeof ((_b = promotionCoupon === null || promotionCoupon === void 0 ? void 0 : promotionCoupon.data) === null || _b === void 0 ? void 0 : _b.discount) === "object" && promotionCoupon.data.discount !== null
                        ? promotionCoupon.data.discount.code
                        : null) ||
                "";
            return normalizedCode.trim().toUpperCase();
        }
        cleanupPromo4uUI() {
            var _a, _b;
            (_a = document.querySelector(".promos4u-info")) === null || _a === void 0 ? void 0 : _a.remove();
            (_b = document.querySelector(".btn-open-coupon")) === null || _b === void 0 ? void 0 : _b.remove();
            const login = document.querySelector(".popup-login");
            if (login) {
                login.classList.add("hidden");
                login.remove();
            }
        }
        verifyPromotion() {
            const SESSION_STORAGE = "insider:cart:promotionCoupon";
            const listCouponBlocked = this.getAttribute("data-list-blocked-coupons");
            if (!listCouponBlocked) {
                this.debugPromotionStatus("allowed", "no blocked coupons configured");
                return "allowed";
            }
            const normalize = (value) => (value || "").trim().toUpperCase();
            const couponsBlocked = listCouponBlocked
                .split(",")
                .map((c) => normalize(c))
                .filter(Boolean);
            const identifierFallback = this.getAttribute("data-identifier-fallback") || "collection-for-you";
            const fallbackElement = document.getElementById(identifierFallback);
            this.fallbackElement = fallbackElement;
            const raw = sessionStorage.getItem(SESSION_STORAGE);
            if (!raw) {
                this.debugPromotionStatus("pending", "sessionStorage empty", {
                    sessionKey: SESSION_STORAGE,
                });
                return "pending";
            }
            let promotionCoupon = null;
            try {
                promotionCoupon = JSON.parse(raw);
            }
            catch (error) {
                console.warn("[verifyPromotion] erro ao fazer parse do coupon:", raw, error);
                this.debugPromotionStatus("allowed", "invalid JSON in sessionStorage", { raw });
                return "allowed";
            }
            const couponCurrent = this.getEffectivePromotionCouponCode(promotionCoupon);
            const isBlocked = !!couponCurrent && couponsBlocked.includes(couponCurrent);
            if (isBlocked) {
                this.cleanupPromo4uUI();
                if (fallbackElement) {
                    fallbackElement.style.display = "block";
                }
                this.style.display = "none";
                this.debugPromotionStatus("blocked", "coupon in blocked list", {
                    couponCurrent,
                    couponsBlocked,
                });
                return "blocked";
            }
            if (fallbackElement) {
                fallbackElement.style.display = "none";
            }
            this.debugPromotionStatus("allowed", "coupon not blocked", {
                couponCurrent,
            });
            return "allowed";
        }
        runTest() {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                try {
                    if (this.verifyPromotion() === "blocked") {
                        this.debugLog("runTest:aborted because promotion is blocked");
                        return;
                    }
                    const stableContext = yield ((_a = getStatsigClient()) === null || _a === void 0 ? void 0 : _a.getAsyncContext());
                    this.statsigStableId = (_b = stableContext === null || stableContext === void 0 ? void 0 : stableContext.stableID) !== null && _b !== void 0 ? _b : null;
                    this.debugLog("runTest:stable context", { stableId: this.statsigStableId });
                    const persistedModelData = this.loadModelFromStorage();
                    if (persistedModelData) {
                        this.debugLog("runTest:using persisted model data");
                        this.applyLayoutChanges(persistedModelData);
                        return;
                    }
                    const shouldSend = shouldSendPayload(["first_load", "stable_id"], MODEL_KEY, "every");
                    if (!shouldSend) {
                        this.debugLog("runTest:shouldSendPayload false -> fallback");
                        this.activeFallback();
                        return;
                    }
                    const experimentManager = yield getOrCreateStatsigManager();
                    if (!(yield experimentManager.checkGate(this.statsigGate))) {
                        this.debugLog("runTest:gate closed -> fallback", { gate: this.statsigGate });
                        this.activeFallback();
                        return;
                    }
                    const layer = yield experimentManager.getLayer(this.statsigLayer);
                    if (!layer) {
                        this.debugLog("runTest:layer missing -> fallback", { layer: this.statsigLayer });
                        this.activeFallback();
                        return;
                    }
                    const allocatedExperiment = layer.__value.allocatedExperiment || EXPERIMENT.allocated_experiment;
                    const normalizedAllocatedExperiment = (allocatedExperiment || "").replace(/\s+/g, "");
                    const isHoldoutVariant = /(?:^|-)holdout(?:-|$)|(?:^|-)control(?:-|$)/i.test(normalizedAllocatedExperiment);
                    const isKnownTreatmentVariant = /(?:^|-)random(?:-|$)/i.test(normalizedAllocatedExperiment) ||
                        /(?:^|-)embedding-v1(?:-|$)/i.test(normalizedAllocatedExperiment);
                    this.debugLog("runTest:allocated experiment", {
                        allocatedExperiment,
                        normalizedAllocatedExperiment,
                        isHoldoutVariant,
                        isKnownTreatmentVariant,
                    });
                    this.modelUrl = layer.get("modelUrl");
                    if (!this.modelUrl) {
                        this.debugLog("runTest:modelUrl missing -> fallback");
                        this.activeFallback();
                        return;
                    }
                    ;
                    const includeFields = [
                        "customer_id",
                        "stable_id",
                        "allocated_experiment",
                        "cart",
                        "utms",
                        "products",
                        "collections",
                    ];
                    const payload = yield buildModelRequestPayload({
                        customer_id: this.customerId || null,
                        stable_id: this.statsigStableId || undefined,
                        allocated_experiment: normalizedAllocatedExperiment || undefined,
                    }, includeFields);
                    const modelData = (yield this.modelManager.getModel(this.modelUrl, payload, { timeout: this.REQUEST_TIMEOUT_MS }, MODEL_KEY, includeFields));
                    this.debugLog("runTest:model response received", {
                        hasModelData: !!modelData,
                        discountValue: modelData === null || modelData === void 0 ? void 0 : modelData.discount_value,
                        productCount: (_c = modelData === null || modelData === void 0 ? void 0 : modelData.product_handles) === null || _c === void 0 ? void 0 : _c.length,
                        forceLogin: modelData === null || modelData === void 0 ? void 0 : modelData.force_login,
                    });
                    if (isHoldoutVariant) {
                        this.debugLog("runTest:allocated experiment marked as holdout/control -> fallback", {
                            allocatedExperiment,
                            normalizedAllocatedExperiment,
                        });
                        this.activeFallback();
                    }
                    else {
                        this.debugLog("runTest:applying layout changes");
                        this.applyLayoutChanges(modelData);
                    }
                }
                catch (error) {
                    console.log("ERROR in Statsig:", error);
                }
            });
        }
        activeFallback() {
            var _a;
            this.debugLog("activeFallback:triggered");
            this.cleanupPromo4uUI();
            if (this.fallbackElement) {
                this.fallbackElement.style.display = "block";
            }
            this.style.display = "none";
            (_a = document.querySelector(".promos-4u")) === null || _a === void 0 ? void 0 : _a.remove();
        }
        applyLayoutChanges(response) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a;
                this.debugLog("applyLayoutChanges:start", {
                    hasResponse: !!response,
                    discountValue: response === null || response === void 0 ? void 0 : response.discount_value,
                    productCount: (_a = response === null || response === void 0 ? void 0 : response.product_handles) === null || _a === void 0 ? void 0 : _a.length,
                    forceLogin: response === null || response === void 0 ? void 0 : response.force_login,
                });
                if (this.verifyPromotion() === "blocked") {
                    this.debugLog("applyLayoutChanges:aborted because promotion is blocked");
                    return;
                }
                if (!response || !response.product_handles || response.product_handles.length === 0) {
                    this.debugLog("applyLayoutChanges:missing product handles -> fallback");
                    this.activeFallback();
                    return;
                }
                ;
                const productGrid = document.querySelector("#product-grid");
                if (!productGrid) {
                    this.debugLog("applyLayoutChanges:product grid not found -> fallback");
                    this.activeFallback();
                    return;
                }
                const isGuest = this.customerId ? false : true;
                const hasCouponDiscount = response.discount_value > 0;
                const forceLogin = (isGuest) ? response.force_login : false;
                const urls = response.product_handles.map(h => `/products/${h}`);
                const productCards = yield this.fetchProductCards(urls);
                if (!productCards) {
                    this.debugLog("applyLayoutChanges:failed to fetch product cards -> fallback");
                    this.activeFallback();
                    return;
                }
                this.debugLog("applyLayoutChanges:product cards fetched", {
                    count: productCards.length,
                });
                this.coupon = hasCouponDiscount
                    ? this.getCouponByDiscountValue(response.discount_value)
                    : null;
                this.debugLog("applyLayoutChanges:coupon resolved from discount", {
                    coupon: this.coupon,
                    hasCouponDiscount,
                });
                if (hasCouponDiscount && this.coupon) {
                    this.clearStalePromos4UPreviewCoupon();
                }
                productGrid.innerHTML = "";
                productCards.forEach((card, index) => {
                    const li = this.createCardElement(card);
                    if (!li)
                        return;
                    this.handleGuestCard(li, forceLogin);
                    this.setupPriceComponent(li, response.discount_value);
                    this.setCardPosition(li, index);
                    productGrid.appendChild(li);
                });
                const login = document.querySelector(".popup-login");
                if (forceLogin && login) {
                    login.classList.remove("hidden");
                }
                if (hasCouponDiscount && (!forceLogin || !isGuest || (forceLogin && !isGuest))) {
                    this.debugLog("applyLayoutChanges:calling handleLoggedUserCoupon", {
                        forceLogin,
                        isGuest,
                    });
                    yield this.handleLoggedUserCoupon(response);
                }
            });
        }
        createCardElement(card) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(`<li class="grid__item">${card}</li>`, "text/html");
            return doc.body.firstElementChild;
        }
        handleGuestCard(li, isGuest) {
            if (isGuest) {
                this.lockGuestCard(li);
            }
        }
        setupPriceComponent(li, discountValue) {
            if (discountValue <= 0)
                return;
            const priceEl = li.querySelector("price-normalize");
            if (!priceEl)
                return;
            if (!this.coupon)
                return;
            // Keep coupon hidden until explicit activation in the popup.
            priceEl.setAttribute("data-is-to-show-coupon-discount", "false");
            priceEl.setAttribute("data-hide-coupon-message", "true");
            priceEl.setAttribute("data-default-discount-code", this.coupon);
            priceEl.setAttribute("data-timestamp", `promos4u:preview-coupon-${Date.now()}`);
        }
        clearStalePromos4UPreviewCoupon() {
            var _a;
            const recommendedCoupon = (this.coupon || "").trim().toUpperCase();
            if (!recommendedCoupon)
                return;
            const storedPromotionCoupon = this.getPromotionCouponFromStorage();
            if (!storedPromotionCoupon || storedPromotionCoupon.promos4u_preview !== true)
                return;
            const storedCoupon = this.getEffectivePromotionCouponCode(storedPromotionCoupon);
            if (storedCoupon !== recommendedCoupon)
                return;
            const sanitized = Object.assign(Object.assign({}, storedPromotionCoupon), { promos4u_preview: false, force: false });
            if ((sanitized.code || "").trim().toUpperCase() === recommendedCoupon) {
                delete sanitized.code;
            }
            if ((sanitized.discount || "").trim().toUpperCase() === recommendedCoupon) {
                delete sanitized.discount;
            }
            const rawDiscountData = (_a = sanitized.data) === null || _a === void 0 ? void 0 : _a.discount;
            const dataCode = typeof rawDiscountData === "string"
                ? rawDiscountData
                : typeof rawDiscountData === "object" && rawDiscountData !== null
                    ? rawDiscountData.code || ""
                    : "";
            if ((dataCode || "").trim().toUpperCase() === recommendedCoupon) {
                delete sanitized.data;
            }
            sessionStorage.setItem(PROMOTION_COUPON_STORAGE_KEY, JSON.stringify(sanitized));
            window.dispatchEvent(new CustomEvent("PromotionCouponReady"));
            this.debugLog("clearStalePromos4UPreviewCoupon:cleaned stale preview coupon", {
                recommendedCoupon,
            });
        }
        setCardPosition(li, index) {
            const cardEl = li.querySelector(".product-card-wrapper .card");
            if (cardEl) {
                cardEl.setAttribute("data-gtm-element-position", String(index + 1));
            }
        }
        getPromotionCouponFromStorage() {
            const raw = sessionStorage.getItem(PROMOTION_COUPON_STORAGE_KEY);
            if (!raw)
                return null;
            try {
                return JSON.parse(raw);
            }
            catch (error) {
                console.warn("[promos4u] erro ao fazer parse do promotionCoupon:", raw, error);
                return null;
            }
        }
        isCurrentCouponAlreadyApplied() {
            const recommendedCoupon = (this.coupon || "").trim().toUpperCase();
            if (!recommendedCoupon)
                return false;
            try {
                const currentUrl = new URL(window.location.href);
                const couponFromQuery = (currentUrl.searchParams.get("cupom") || "").trim().toUpperCase();
                if (couponFromQuery && couponFromQuery === recommendedCoupon) {
                    return true;
                }
            }
            catch (_a) {
                // Ignore malformed URL edge cases.
            }
            const storedPromotionCoupon = this.getPromotionCouponFromStorage();
            const storedCoupon = this.getEffectivePromotionCouponCode(storedPromotionCoupon);
            if ((storedPromotionCoupon === null || storedPromotionCoupon === void 0 ? void 0 : storedPromotionCoupon.promos4u_preview) === true && storedCoupon === recommendedCoupon) {
                return false;
            }
            return !!storedCoupon && storedCoupon === recommendedCoupon;
        }
        handleLoggedUserCoupon(response) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.listCoupon)
                    return;
                if (this.isCurrentCouponAlreadyApplied()) {
                    this.debugLog("handleLoggedUserCoupon:coupon already applied, skipping popup", {
                        coupon: this.coupon,
                    });
                    this.cleanupPromo4uUI();
                    return;
                }
                this.debugLog("handleLoggedUserCoupon:start", {
                    discountValue: response.discount_value,
                });
                const shouldShowBanner = () => {
                    this.showCouponBanner(response.discount_value);
                    this.debugLog("handleLoggedUserCoupon:banner check", {
                        hasPopup: !!document.querySelector(".promos4u-info"),
                        hasFloatingButton: !!document.querySelector(".btn-open-coupon"),
                    });
                    return !!document.querySelector(".promos4u-info") || !!document.querySelector(".btn-open-coupon");
                };
                if (shouldShowBanner())
                    return;
                const retryStartAt = Date.now();
                const retryWindowMs = this.PROMOTION_RETRY_WINDOW_MS;
                const retryIntervalMs = this.PROMOTION_RETRY_INTERVAL_MS;
                let retryTimeoutId = null;
                let done = false;
                const cleanup = () => {
                    if (done)
                        return;
                    done = true;
                    window.removeEventListener("PromotionCouponReady", onPromotionReady);
                    if (retryTimeoutId !== null) {
                        clearTimeout(retryTimeoutId);
                        retryTimeoutId = null;
                    }
                };
                const tryRenderPopup = () => {
                    if (done)
                        return;
                    const status = this.verifyPromotion();
                    if (status === "blocked") {
                        this.debugLog("handleLoggedUserCoupon:retry stopped because status is blocked");
                        cleanup();
                        return;
                    }
                    if (shouldShowBanner()) {
                        this.debugLog("handleLoggedUserCoupon:retry succeeded, popup rendered");
                        cleanup();
                        return;
                    }
                    if (Date.now() - retryStartAt >= retryWindowMs) {
                        this.debugLog("handleLoggedUserCoupon:retry timeout without popup", {
                            retryWindowMs,
                        });
                        cleanup();
                        return;
                    }
                    retryTimeoutId = window.setTimeout(tryRenderPopup, retryIntervalMs);
                };
                const onPromotionReady = () => {
                    tryRenderPopup();
                };
                window.addEventListener("PromotionCouponReady", onPromotionReady);
                tryRenderPopup();
            });
        }
        showCouponBanner(discountValue) {
            var _a, _b, _c;
            if (discountValue <= 0) {
                this.debugLog("showCouponBanner:skipped because discount is zero", { discountValue });
                return;
            }
            if (this.isCurrentCouponAlreadyApplied()) {
                this.debugLog("showCouponBanner:coupon already applied, not rendering", {
                    coupon: this.coupon,
                });
                return;
            }
            if (this.verifyPromotion() === "blocked") {
                this.debugLog("showCouponBanner:aborted because promotion is blocked");
                return;
            }
            if (document.querySelector(".promos4u-info") || document.querySelector(".btn-open-coupon")) {
                this.debugLog("showCouponBanner:already rendered, skipping duplicate");
                return;
            }
            this.debugLog("showCouponBanner:rendering", { discountValue });
            const discount = discountValue * 100;
            const applyCoupon = this.getAttribute("data-apply-coupon-text") || "Aplicar cupom";
            const imagePopupCoupon = this.getAttribute("data-image-popup-coupon") || null;
            const titleCoupon = this.getAttribute("data-title-coupon") || "Cupom disponível!";
            const textGetCoupon = this.getAttribute("data-text-get-coupon") || "Obter cupom";
            const removeCoupon = this.getAttribute("data-remove-coupon-text") || "Não quero cupom";
            const textCoupon = ((_a = this.getAttribute("data-text-coupon")) === null || _a === void 0 ? void 0 : _a.replace("|COUPON|", String(discount))) || "";
            const template = `
          <div class="promos4u-info">
            <div class="promos4u-info-text">
              <div class="image-coupon">
                ${imagePopupCoupon ? `<img src="${imagePopupCoupon}"/>` : ""}
              </div>
              <div class="container">
                <h3>${titleCoupon}</h3>
                <p>${textCoupon}</p>
                <button class="promos4u-apply-btn button" type="button">
                  <span>${applyCoupon}</span>
                  <div class="loading-overlay hidden">
                    <div class="loading-overlay__spinner">
                      <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                      </svg>
                    </div>
                  </div>
                </button>
                <button class="promos4u-remove-btn button" type="button">${removeCoupon}</button>
              </div>
            </div>
          </div>
          <span class="btn-flutuante btn-open-coupon">${textGetCoupon}</span>
        `;
            document.body.insertAdjacentHTML("beforeend", template);
            const btnOpenCoupon = document.querySelector(".btn-open-coupon");
            const initialPopupCoupon = document.querySelector(".promos4u-info");
            if (initialPopupCoupon) {
                initialPopupCoupon.style.display = "flex";
                this.debugLog("showCouponBanner:popup opened immediately");
            }
            if (btnOpenCoupon) {
                btnOpenCoupon.style.display = "none";
            }
            btnOpenCoupon === null || btnOpenCoupon === void 0 ? void 0 : btnOpenCoupon.addEventListener("click", () => {
                if (this.verifyPromotion() === "blocked")
                    return;
                const popupCoupon = document.querySelector(".promos4u-info");
                if (popupCoupon)
                    popupCoupon.style.display = "flex";
                if (btnOpenCoupon)
                    btnOpenCoupon.style.display = "none";
            });
            (_b = document
                .querySelector(".promos4u-apply-btn")) === null || _b === void 0 ? void 0 : _b.addEventListener("click", () => __awaiter(this, void 0, void 0, function* () { return yield this.showApplyingCoupon(); }));
            (_c = document
                .querySelector(".promos4u-remove-btn")) === null || _c === void 0 ? void 0 : _c.addEventListener("click", () => {
                const promoInfo = document.querySelector(".promos4u-info");
                if (promoInfo)
                    promoInfo.style.display = "none";
                if (btnOpenCoupon)
                    btnOpenCoupon.style.display = "block";
            });
        }
        getCouponByDiscountValue(value) {
            const couponsList = JSON.parse(this.listCoupon);
            const percentage = value * 100;
            for (const code in couponsList) {
                if (Object.prototype.hasOwnProperty.call(couponsList, code) && couponsList[code].discount === percentage) {
                    return code;
                }
            }
            return null;
        }
        showApplyingCoupon() {
            return __awaiter(this, void 0, void 0, function* () {
                const BoxInfo = document.querySelector('.promos4u-info-text');
                const btnApply = BoxInfo.querySelector('.promos4u-apply-btn');
                const loadingOverlay = btnApply.querySelector('.loading-overlay');
                const removeBtn = BoxInfo.querySelector(".promos4u-remove-btn");
                const textBtn = btnApply.querySelector('span');
                const text = BoxInfo.querySelector('p');
                text.textContent = 'Aplicando cupom...';
                removeBtn.remove();
                textBtn.classList.add('hidden');
                loadingOverlay.classList.remove('hidden');
                try {
                    yield this.applyCouponDiscounts();
                }
                catch (error) {
                    console.log("Error applying coupon:", error);
                    text.textContent = 'Erro ao aplicar o cupom. Tente novamente.';
                    textBtn.classList.remove('hidden');
                }
                finally {
                    loadingOverlay.classList.add('hidden');
                }
            });
        }
        applyCouponDiscounts() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.coupon)
                    return;
                try {
                    const storedPromotionCoupon = this.getPromotionCouponFromStorage();
                    if (storedPromotionCoupon === null || storedPromotionCoupon === void 0 ? void 0 : storedPromotionCoupon.promos4u_preview) {
                        sessionStorage.setItem(PROMOTION_COUPON_STORAGE_KEY, JSON.stringify(Object.assign(Object.assign({}, storedPromotionCoupon), { promos4u_preview: false })));
                    }
                    yield this.insertCouponInCheckout(this.coupon);
                    const link = window.location.href;
                    const url = new URL(link);
                    window.location.href = url.origin + url.pathname + '?force=1&cupom=' + this.coupon;
                }
                catch (error) {
                    console.log("Error applying coupon:", error);
                }
            });
        }
        insertCouponInCheckout(promotionCoupon) {
            return __awaiter(this, void 0, void 0, function* () {
                const discountApplyUrl = `/discount/${promotionCoupon}?v=${Date.now()}`;
                yield fetch(discountApplyUrl);
            });
        }
        lockGuestCard(el) {
            const quickAdd = el.querySelector("product-quick-add");
            if (quickAdd)
                quickAdd.remove();
            const btnQuickAdd = el.querySelector("button.product-quick-add__btn");
            if (btnQuickAdd)
                btnQuickAdd.remove();
            el.querySelectorAll(".card-link").forEach(link => {
                const anchor = link;
                anchor.href = "#";
                anchor.addEventListener("click", (e) => {
                    e.preventDefault();
                    const btn = document.querySelector(".btn-open-popup-login");
                    const popup = document.querySelector('.popup-login');
                    if (popup)
                        popup.style.display = 'flex';
                    if (btn)
                        btn.style.display = 'none';
                    return false;
                });
            });
            const priceContent = el.querySelector(".card__content .card-information price-normalize");
            if (priceContent) {
                priceContent.classList.add("unlocked");
                priceContent.insertAdjacentHTML("beforeend", `<div class="unlocked-info"><p>Desbloqueie fazendo o login</p></div>`);
            }
        }
        fetchProductCards(urls) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const results = yield Promise.all(urls.map((url) => __awaiter(this, void 0, void 0, function* () {
                        const res = yield fetch(url + (url.includes("?") ? "&" : "?") + "view=promoCollectionForYou");
                        return res.ok ? res.text() : null;
                    })));
                    return results.filter(Boolean);
                }
                catch (error) {
                    console.log(`[Statsig][${EXPERIMENT.name}] Failed to fetch product cards`, error);
                    return null;
                }
            });
        }
        loadModelFromStorage() {
            const storage = getSafeStorage();
            try {
                const raw = storage.getItem(MODEL_KEY);
                const parsed = raw ? JSON.parse(raw) : null;
                return parsed && typeof parsed === "object" ? parsed : null;
            }
            catch (_a) {
                return null;
            }
        }
    });
